export default "__VITE_ASSET__CAs9USZc__"